import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Product} from '../../../shared/api/model/product';
import {SettingsService} from '../../../shared/api/resources/settings/settings.service';
import {AgentService} from '../../../shared/api/resources/agent/agent.service';
import * as moment from 'moment';
import {Event} from '../../../shared/api/model/event';
import {StaticUtils} from '../../../shared/utils/static-utils';

@Component({
  selector: 'app-product-events',
  templateUrl: './product-events.component.html',
  styleUrls: ['./product-events.component.scss']
})
export class ProductEventsComponent implements OnInit, OnDestroy {
  private _sub: any;
  private _dateRange = {
    start: moment(),
    end: moment()
  };
  private _paxFilter = 0;
  private _datePickerRange = 0;
  moment = moment;
  utils = StaticUtils;
  partnerId: number;
  productId: number;
  product: Product;
  events: Event[] = [];
  groupedEvents = {};
  gettingEvents = false;
  eventsGenderPrices = [];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _settingsService: SettingsService,
    private _agentService: AgentService) { }

  ngOnInit() {
    this._sub = this._route.params.subscribe(params => {
      this.partnerId = parseInt(params['id'], 10);
      this.productId = parseInt(params['productId'], 10);

      this.reloadEvents();

      this._agentService.getProduct(this.partnerId.toString(10), this.productId).subscribe(
        (product: Product) => {
          this.product = product;
        }
      );
    });
  }

  reloadEvents() {
    this.gettingEvents = true;
    this._agentService.getEventsByProduct(
      this.partnerId.toString(10), this.productId.toString(10),
      StaticUtils.formatDateForBackend(this._dateRange.start),
      StaticUtils.formatDateForBackend(this._dateRange.end)
    ).subscribe(
      (res: any) => {
        this.events = [];
        for (const event of res.events) {
          if (this._paxFilter === 0 || this._paxFilter <= event.quantityAvailable) {
            this.events.push(event);
          }
        }
        this.eventsGenderPrices = this.getEventsGenderPrices();
        this.groupedEvents = StaticUtils.groupBy(this.events, (v: Event) => {
          return moment(v.start).format('DD MMM YYYY');
        });
        this.groupedEvents = this.fillMissingDays(this.groupedEvents);
      },
      undefined,
      () => {
        this.gettingEvents = false;
      }
    );
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  fillMissingDays(groupedEvents: any): any {
    const result = {};

    let previousDate: string;
    for (const day in groupedEvents) {
      if (groupedEvents.hasOwnProperty(day)) {
        if (!previousDate) {
          previousDate = day;
        }
        const diff = moment(day).diff(moment(previousDate), 'days');
        if (diff > 1) {
          for (let i = 1; i < diff; i++) {
            result[moment(previousDate).add(i, 'days').format('DD MMM YYYY')] = [];
          }
        }
        previousDate = day;
        result[day] = groupedEvents[day];
      }
    }

    return result;
  }

  getEventsGenderPrices() {
    const eventsGenderPrices = [];
    for (const event of this.events) {
      for (const eventGenderPrice of event.eventGenderPrices) {
        let contains = false;

        for (const genderPrice of eventsGenderPrices) {
          if (eventGenderPrice.audienceType === genderPrice.audienceType) {
            contains = true;
            break;
          }
        }

        if (!contains) {
          eventsGenderPrices.push(eventGenderPrice);
        }
      }
    }
    return eventsGenderPrices;
  }

  today() {
    this._dateRange.start = moment();
    this._dateRange.end = this._dateRange.start.clone();
    this.datePickerRange = 0;
  }

  day() {
    this._dateRange.end = this._dateRange.start.clone();
    this.datePickerRange = 0;
  }

  week() {
    this._dateRange.end = this._dateRange.start.clone().add(8, 'days');
    this.datePickerRange = 7;
  }

  get dateRange(): any {
    return this._dateRange;
  }

  set dateRange(value: any) {
    this._dateRange = value;
    this.reloadEvents();
  }

  get paxFilter(): number {
    return this._paxFilter;
  }

  set paxFilter(value: number) {
    this._paxFilter = value;
    this.reloadEvents();
  }

  get datePickerRange(): number {
    return this._datePickerRange;
  }

  set datePickerRange(value: number) {
    this._datePickerRange = value;
    this.reloadEvents();
  }
}



// WEBPACK FOOTER //
// ./src/app/experiences/products/product-events/product-events.component.ts